import React from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/websiteHistory.scss";
// Bootstrap
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";

function WebsiteHistory() {
  return (
    <Container>
      <div id="webHistoryBox">
        <div className="webHistoryTitle">網頁更新紀錄</div>
        <div className="webHistoryForm">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>版本</th>
                <th>更新內容</th>
              </tr>
            </thead>
            <tbody>
              <tr className="1.05">
                <td>1.05</td>
                <td>
                  <div>1. 更新低層架構體系。</div>
                  <div>
                    2.
                    更新現在天氣及圖像：所有氣象資料均可顯示，並可縮放。取消顯示1小時雨量(放大)。
                  </div>
                </td>
              </tr>
              <tr className="1.04">
                <td>1.04</td>
                <td>
                  <div>1. 更新低層架構體系。</div>
                  <div>
                    2.
                    更新現在天氣及圖像：更新顯示顏色。增加長洲泳灘及香港航海學校風速風向及一小時最大陣風資料。
                  </div>
                </td>
              </tr>
              <tr className="1.03">
                <td>1.03</td>
                <td>
                  <div>1. 更新低層架構體系，加快提供氣象資料的速度。</div>
                  <div>2. 增加海上氣象頁面。</div>
                  <div>3. 更新現在天氣及圖像：更新格式。並增加1小時雨量。</div>
                  <div>4. 新增華南海域天氣預報，並調整顯示內容。</div>
                </td>
              </tr>
              <tr className="1.02">
                <td>1.02</td>
                <td>
                  <div>1. 更新低層架構體系。</div>
                  <div>2. 增加關於頁面。</div>
                  <div>3. 更新主頁頁面格式。</div>
                  <div>
                    4.
                    更新現在天氣及圖像：顯示過去一小時最大陣風，取代原最大陣風分頁。並同時更新其他分頁的格式。
                  </div>
                  <div>5. 增加顯示天文台有感地震報告信息。</div>
                </td>
              </tr>
              <tr className="1.01">
                <td>1.01</td>
                <td>
                  <div>1. 增加顯示天文台的天氣警告及即時天氣信息。</div>
                  <div>2. 修正氣溫顯示。</div>
                </td>
              </tr>
              <tr className="1.00">
                <td>1.00</td>
                <td>初始版本：提供氣象預報及即時天氣資料。</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
}

export default WebsiteHistory;
